import * as React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'ramda';

import { ListingLayout } from '../../components/ListingLayout';
import { RealtorCard } from '../../components/RealtorCard';
import { getRealtorsItems } from '../../selectors/listing';
import { RealtorBannerContainer } from '../RealtorBannerContainer';
import { CardAvatarContainer } from '../CardAvatarContainer';
import { EmptyListingStubContainer } from '../EmptyListingStubContainer';
import { useOpenCard } from '../../utils/openCard';
import { NoSsr } from '@cian/react-utils';

export function RealtorsListingContainer() {
  const realtorsItems = useSelector(getRealtorsItems);
  const onClick = useOpenCard();

  if (isEmpty(realtorsItems)) {
    return <EmptyListingStubContainer />;
  }

  return (
    <ListingLayout>
      {realtorsItems.map(
        (
          {
            cianUserId,
            age,
            agencyName,
            review,
            name,
            offersCount,
            rate,
            reviewsCount,
            userTrustLevelNumber,
            userTrustLevelName,
            hasRgrParticipation,
          },
          i,
        ) => {
          return (
            <React.Fragment key={cianUserId}>
              <NoSsr>
                <RealtorBannerContainer currentIndex={i} listLength={realtorsItems.length} />
              </NoSsr>
              <RealtorCard
                onClick={() => onClick(cianUserId)}
                previewImg={<CardAvatarContainer agentId={cianUserId} isCircleImage={true} />}
                agentId={cianUserId}
                age={age}
                agencyName={agencyName}
                hasRgrParticipation={hasRgrParticipation}
                review={review}
                name={name}
                offersCount={offersCount}
                rate={rate}
                reviewsCount={reviewsCount}
                levelName={userTrustLevelName}
                levelNumber={userTrustLevelNumber}
              />
              <NoSsr>
                <RealtorBannerContainer currentIndex={i} listLength={realtorsItems.length} isLast />
              </NoSsr>
            </React.Fragment>
          );
        },
      )}
    </ListingLayout>
  );
}
